import React, { useState } from "react";
import StarRating from "./StarRating";
import { apiurl } from "../../Constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function Writeacomment({ product_id }) {
  const [rating, setRating] = useState(0); // Handle rating
  const [comment, setComment] = useState(""); // Handle comment
  const [error, setError] = useState(null); // Handle errors

  const navigate = useNavigate();

  const user_id = localStorage.getItem("userId");

  const handleAddreviews = async (e) => {
    e.preventDefault();

    if (!user_id) {
      navigate("/login");
    }

    // Ensure both rating and comment are provided
    if (!rating || !comment) {
      setError("Please provide both a rating and a comment.");
      return;
    }

    try {
      const response = await axios.post(apiurl + "review", {
        user_id, // pass user_id
        product_id, // pass product_id
        ratting: rating, // pass rating
        comment, // pass comment
      });

      toast.success(response.data.message);
      setError(null); // Clear error if successful
      setComment("");
      setRating(null);
    } catch (error) {
      console.error("Error adding review:", error);
      setError("Failed to submit the review. Please try again.");
    }
  };

  return (
    <section className="writeacomment_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <h4>Tell us about the product</h4>
            <form onSubmit={handleAddreviews}>
              <div className="add_review text-center">
                <StarRating rating={rating} onRatingChange={setRating} />
              </div>
              <div className="inner-box mt-4">
                <textarea
                  rows="5"
                  placeholder="Write your comments"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></textarea>
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}
              <div
                className="inner-box-two mt-4"
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <div className="submit_btn">
                  <button className="btn_1" type="submit">
                    Submit Review
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Writeacomment;
